import React from 'react';

class AutoTextarea extends React.Component {

    #textarea;

    constructor( props ) {

        super( props );

        this.resize    = this.resize.bind( this );
        this.#textarea = React.createRef();

    }

    componentDidMount() {

        this.resize();

    }

    resize() {

        this.#textarea.current.style.height = "auto";
        this.#textarea.current.style.height = this.#textarea.current.scrollHeight + "px";

    }

    render() {

        return (

            <div className="auto-textarea">

                <textarea
                    id={this.props.id}
                    name={this.props.name}
                    onChange={this.props.onChange}
                    onInput={this.resize}
                    disabled={this.props.readonly}
                    ref={this.#textarea}
                    value={this.props.value === null || this.props.value === 'null' ? '' : this.props.value}
                />

            </div>

        );

    }

}

export default AutoTextarea;